import { registerSW } from 'virtual:pwa-register'

export const PWA_UPDATE_AVAILABLE_EVENT = 'reeco:pwa-update-available'

/** @type {(reloadPage?: boolean) => Promise<void>} */
let applyServiceWorkerUpdate = async (reloadPage) => {
  if (reloadPage && typeof window !== 'undefined') {
    window.location.reload()
  }
}

/**
 * Register the PWA service worker (production build). When a new version is waiting,
 * dispatches {@link PWA_UPDATE_AVAILABLE_EVENT} so the UI can ask the user to update.
 */
export function initPwaServiceWorker() {
  if (typeof window === 'undefined') return

  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      window.dispatchEvent(new CustomEvent(PWA_UPDATE_AVAILABLE_EVENT))
    },
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return
      const ping = () => {
        registration.update().catch(() => {})
      }
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') ping()
      })
      setInterval(ping, 4 * 60 * 60 * 1000)
    },
    onRegisterError(err) {
      console.warn('PWA service worker registration failed', err)
    },
  })

  applyServiceWorkerUpdate = updateSW
}

/**
 * After user confirms update: ask the waiting service worker to activate.
 * vite-plugin-pwa's returned fn only calls skipWaiting; reload is supposed to happen on
 * Workbox `controlling` — that often never fires (no waiting SW, registration edge cases).
 * Always hard-reload after await so the button always does something useful.
 */
export async function triggerPwaReload() {
  try {
    await applyServiceWorkerUpdate(true)
  } catch (e) {
    console.warn('PWA update apply failed', e)
  }
  window.location.reload()
}
